import React from "react";

export default function RadioText({ title }: { title: string }) {
  return (
    <span className="font-normal text-[18px] text-[#1F1125] lowercase">{title}</span>
  )
}
